import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Pagination } from '@ok/okd';
import URL from '@pages/index/common/URL';
import { toLocale } from '@common/i18n';
import util from '../../entries/common/util';

import './index.less';

const { formatTimestamp } = util;

const App = () => {
  const [articles, setArticles] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    getArticles(1);
  }, []);

  const onPageChange = (pageNum) => {
    setCurrent(pageNum);
    getArticles(pageNum);
  };

  const getArticles = async (pageNum) => {
    await fetch(
      `${window.location.protocol}//${window.location.host}${URL.GET_ARTICLES}?pageSize=12&page=${pageNum}`
    )
      .then(async (result) => {
        const contentType = result.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          return result.json();
        } else {
          const res = await result.text()
          throw new Error(res);
        }
      })
      .then((data) => {
        if (data?.code !== 0) {
          throw data;
        }
        setArticles(data.data.records);
        setCurrent(data.data.page);
        setTotalPage(data.data.totalPage >= 4 ? 4 : data.data.totalPage);
        setTotal(data.data.total);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      })
      .catch((e) => {
        console.log(e);
        setArticles([]);
        setCurrent(1);
        setTotalPage(1);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
  };

  return (
    <div className="container">
      <div className="market-news-box">
        <div className="market-news-section-inner">
          <div className="title">{toLocale('rss_page_title')}</div>
          <div className="content">
            {articles.map((article) => (
              <div
                key={article.id}
                className="blog-box"
                onClick={() => {
                  window.location.href = `/markets/news/details?id=${article.id}`;
                }}
              >
                <div className="bottom-wrapper-pc">
                  <div className="img-wrapper">
                    <img src={article.thumbnail} alt="img" />
                  </div>
                  <div className="date-wrapper">
                    <div className="date">
                      {formatTimestamp(article.publishTime, 'YYYY/MM/dd')}
                    </div>
                  </div>
                  <div className="title">{article.title}</div>
                  <div className="author">{article.author}</div>
                </div>
                <div className="bottom-wrapper-sm">
                  <div className="content-wrapper">
                    <div className="title">{article.title}</div>
                    <div className="other-wrapper">
                      <div className="date">
                        {formatTimestamp(article.publishTime, 'YYYY/MM/dd')}
                      </div>
                      <div className="author">{article.author}</div>
                    </div>
                  </div>
                  <div className="small-img-wrapper">
                    <img src={article.thumbnail} alt="img" />
                  </div>
                </div>
              </div>
            ))}
            {total === 0 && (
              <div className="no-content">
                現在、新着のニュースはありません。
              </div>
            )}
          </div>
        </div>
      </div>
      <Pagination
        current={current}
        totalPage={totalPage}
        onPageChange={onPageChange}
        align={Pagination.ALIGN.center}
        className="record-pagination"
      />
    </div>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<App />);
